import { AuthResponse } from '@/types/auth';

interface AuthInput {
    email: string;
    password: string;
    first_name?: string;
}

export const signup = async (input: AuthInput) => {
    const response = await fetch('/api/auth/signup', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(input),
    });
    return response.ok ? response : response.json();
};

export const login = async (input: Omit<AuthInput, 'first_name'>) => {
    const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ ...input, mode: 'cookie' }),
    });

    return response.json();
};

export const auth$refresh = async (): Promise<AuthResponse> => {
    const response = await fetch('/api/auth/refresh', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ mode: 'cookie' }),
    }).then((res) => res.json());
    return response?.data ?? '';
};

export const logout = async (): Promise<void> => {
    await fetch('/api/auth/logout', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ mode: 'cookie' }),
    });
};

export const refreshPassword = async (locale: string, email: string, reset_url: string): Promise<boolean> => {
    const response = await fetch('/api/auth/password/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ locale, email, reset_url }),
    });

    return response.ok;
};

export const resetPassword = async (token: string, password: string): Promise<boolean> => {
    const response = await fetch('/api/auth/password/reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
    });
    return response.ok;
};
